(function () {
  function start() {
    var root = document.querySelector('[data-ns-native-promo]');
    if (!root || root.__nsNativePromo) return;
    root.__nsNativePromo = true;

    var modal = root.querySelector('[data-ns-native-promo-modal]');
    var dialog = root.querySelector('.ns-b1g2-dialog');
    var gift = root.querySelector('[data-ns-native-promo-gift]');
    var giftOptions = Array.prototype.slice.call(root.querySelectorAll('[data-ns-native-promo-gift]')).filter(function (option) { return option.dataset.nsGiftAvailable !== 'false'; });
    var allGiftOptions = giftOptions.slice();
    var variantRules = root.querySelector('[data-ns-variant-gift-rules]');
    var versionConfig = variantRules ? JSON.parse(variantRules.textContent) : null;
    var required = Number(root.dataset.required || 1);
    var selected = required === 1 && giftOptions.length === 1 ? [gift] : [];
    var confirmButton = root.querySelector('[data-ns-native-promo-confirm]');
    var skipButton = root.querySelector('[data-ns-native-promo-skip]');
    var errorBox = root.querySelector('[data-ns-native-promo-error]');
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ns-native-promo-close]'));
    var code = root.dataset.discountCode;
    var promoKey = root.dataset.promoKey;
    var label = root.dataset.offerLabel || code;
    var cartUrl = root.dataset.cartUrl || '/cart';
    var pendingForm = null;
    var pendingExtras = [];
    var pendingDestination = 'cart';
    var lastFocused = null;
    var busy = false;
    var claimed = false;
    var claimedQuantity = 0;
    var keepExistingGifts = false;
    var claimStatePromise = null;
    var promotionStartPending = false;
    var giftReady = window.NSLiveEligibility ? window.NSLiveEligibility.hydrateGifts(root).then(function () {
      allGiftOptions = allGiftOptions.filter(function (option) { return option.dataset.nsGiftAvailable !== 'false'; });
      giftOptions = allGiftOptions.slice();
      gift = giftOptions[0];
      if (versionConfig) syncVersionGift(mainForm());
      else selected = required === 1 && giftOptions.length === 1 ? [gift] : [];
    }) : Promise.resolve();

    function routesRoot() { return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'; }
    function requestJson(url, options) {
      return fetch(url, options).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          if (!response.ok) throw new Error(payload.description || payload.message || 'The cart could not be updated.');
          return Array.isArray(payload.items) && typeof payload.item_count === 'number' && window.NSLiveEligibility ? window.NSLiveEligibility.cart(payload) : payload;
        });
      });
    }
    function wait(ms) { return new Promise(function (resolve) { window.setTimeout(resolve, ms); }); }
    function setError(message) { errorBox.textContent = message || ''; errorBox.hidden = !message; }
    function mainForm() {
      // Desktop Ani preview may display complementary forms before the main product.
      // Resolve its existing observed form explicitly; all other pages keep the original behavior.
      var supplement = document.querySelector('ns-ani-desktop-fill:not([hidden])');
      var mainRerender = supplement && supplement.closest('product-rerender[observe-form]');
      var observedForm = mainRerender && document.getElementById(mainRerender.getAttribute('observe-form'));
      if (observedForm && observedForm.matches('form[action*="/cart/add"]')) return observedForm;
      var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
      return forms.find(function (form) { return form.querySelector('buy-buttons') && !form.closest('[id*="quick-buy"], quick-buy-modal, .quick-buy-modal'); }) ||
        forms.find(function (form) { return form.matches('form[is="product-form"]') && !form.closest('[id*="quick-buy"], quick-buy-modal, .quick-buy-modal'); }) || null;
    }
    function isMainForm(form) { return !!form && form === mainForm(); }
    function selectedPurchase(form) { var input = (form || mainForm()) && (form || mainForm()).querySelector('[name="id"]'); return input && input.value; }
    function decorateVersionLabels(id) {
      var picker = document.querySelector('variant-picker[form-id="' + (mainForm() && mainForm().getAttribute('id') || '') + '"]');
      var source = root.querySelector('[data-ns-purchase-variants]');
      if (!picker || !source) return;
      var variants = JSON.parse(source.textContent), current = variants.find(function (v) { return String(v.id) === String(id); });
      if (!current) return;
      var field = picker.querySelector('fieldset');
      if (!field) return;
      field.querySelectorAll('label.block-swatch').forEach(function (option) {
        var title = option.querySelector('.ns-variant-title');
        if (!title) return;
        var purchase = variants.find(function (v) { return v.option1 === title.textContent.trim() && v.option2 === current.option2 && v.option3 === current.option3; });
        if (!purchase) return;
        var rule = (versionConfig.variant_gift_rules || []).find(function (r) { return r.purchase_variant_ids.some(function (v) { return String(v).split('/').pop() === String(purchase.id); }); });
        var badge = option.querySelector('.ns-version-gift-label');
        if (!rule || !rule.label) { if (badge) badge.remove(); option.classList.remove('ns-has-version-gift'); return; }
        option.classList.add('ns-has-version-gift');
        if (!badge) { badge = document.createElement('span'); badge.className = 'ns-variant-badge ns-version-gift-label'; var card = option.querySelector('.ns-variant-card') || option; card.insertBefore(badge, card.firstChild); }
        badge.textContent = rule.label;
      });
    }
    function syncVersionGift(form) {
      if (!versionConfig || busy) return;
      var id = selectedPurchase(form), pool = window.NSLiveEligibility.giftPool(versionConfig, id);
      giftOptions = allGiftOptions.filter(function (o) { var allowed = pool.indexOf(String(o.dataset.variantId)) !== -1 && o.dataset.nsGiftAvailable !== 'false'; o.hidden = !allowed; o.disabled = !allowed; return allowed; });
      gift = giftOptions[0];
      selected = required === 1 && giftOptions.length === 1 ? [gift] : [];
      var rule = (versionConfig.variant_gift_rules || []).find(function (r) { return r.purchase_variant_ids.some(function (v) { return String(v).split('/').pop() === String(id); }); });
      var label = rule && rule.label || versionConfig.default_gift_label || 'FREE gift';
      decorateVersionLabels(id);
      var title = root.querySelector('#ns-native-promo-title');
      if (title) title.textContent = label + ' included';
      var description = root.querySelector('#ns-native-promo-description');
      if (description) description.textContent = giftOptions.length ? 'Your selected saber version includes this gift. Its discount applies automatically in the cart.' : 'This gift is currently unavailable. You can add your saber without a gift.';
      renderSelection();
    }

    function formItem(form, token) {
      var data = new FormData(form);
      var id = Number(data.get('id'));
      var quantity = Math.max(1, Number(data.get('quantity') || 1));
      if (!id) throw new Error('Please select an available product option first.');
      var properties = {};
      data.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') properties[match[1]] = value;
      });
      if (token) {
        properties['_NS promotion offer'] = 'true';
        properties['_NS promotion bundle'] = token;
        properties['_NS promotion key'] = promoKey;
        properties['_NS promotion gift quantity'] = String(required);
      }
      var item = { id: id, quantity: quantity };
      if (Object.keys(properties).length) item.properties = properties;
      var sellingPlan = data.get('selling_plan');
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      return item;
    }
    function giftItem(token, option) {
      return { id: Number((option || gift).dataset.variantId), quantity: 1, properties: {
        '_NS promotion gift': 'true', '_NS promotion bundle': token, '_NS promotion key': promoKey, '_NS promotion gift quantity': String(required)
      }};
    }
    function safeExtras(extras) {
      return (extras || []).filter(function (item) { return item && Number(item.id); }).map(function (item) {
        var next = { id: Number(item.id), quantity: Math.max(1, Number(item.quantity || 1)) };
        if (item.properties && typeof item.properties === 'object') next.properties = item.properties;
        return next;
      });
    }
    function hasValidBundle(cart) {
      return (cart.items || []).some(function (parent) {
        var props = parent.properties || {};
        if (props['_NS promotion offer'] !== 'true' || props['_NS promotion key'] !== promoKey || !props['_NS promotion bundle'] || parent.quantity < 1 || parent.final_line_price <= 0) return false;
        var gifts = (cart.items || []).filter(function (item) {
          var p = item.properties || {};
          return p['_NS promotion gift'] === 'true' && p['_NS promotion key'] === promoKey && p['_NS promotion bundle'] === props['_NS promotion bundle'];
        });
        var allowed = versionConfig ? window.NSLiveEligibility.giftPool(versionConfig, parent.variant_id || parent.id).map(Number) : giftOptions.map(function (o) { return Number(o.dataset.variantId); });
        if (window.NSLiveEligibility && !window.NSLiveEligibility.bundle(cart, parent, gifts)) return false;
        var expectedCount = promoKey === 'choose2' ? gifts.length : required;
        return gifts.length > 0 && gifts.length <= required && gifts.length === expectedCount && gifts.every(function (item) { return item.quantity === 1 && item.original_line_price > 0 && item.final_line_price === 0 && allowed.indexOf(item.id) !== -1; }) &&
          new Set(gifts.map(function (item) { return item.id; })).size === expectedCount;
      });
    }
    function updateTrigger() {
      Array.prototype.slice.call(document.querySelectorAll('[data-ns-native-promo-open]')).forEach(function (button) {
        var copy = button.querySelector('[data-ns-native-promo-trigger-copy]');
        var action = button.querySelector('[data-ns-native-promo-trigger-action]');
        if (copy) copy.textContent = claimed ? 'Your gift is already in the cart' : 'See your included gift';
        if (action) action.textContent = claimed ? 'View cart' : 'View';
      });
    }
    function trigger() {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ns-b1g2-trigger';
      button.setAttribute('data-ns-native-promo-open', '');
      button.innerHTML = '<span class="ns-b1g2-trigger__mark" aria-hidden="true">FREE</span>' +
        '<span class="ns-b1g2-trigger__copy"><strong>' + escapeHtml(label) + '</strong><span data-ns-native-promo-trigger-copy>See your included gift</span></span>' +
        '<span class="ns-b1g2-trigger__action" data-ns-native-promo-trigger-action>View</span>';
      return button;
    }
    function escapeHtml(value) { var div = document.createElement('div'); div.textContent = value; return div.innerHTML; }
    function ensureTrigger() {
      document.body.classList.add('ns-b1g2-enabled');
      if (window.NSPromoAtc && typeof window.NSPromoAtc.refresh === 'function') window.NSPromoAtc.refresh();
    }
    function destinationUrl(destination) {
      return destination === 'shop_pay' ? routesRoot() + 'checkout?payment=shop_pay' : cartUrl;
    }
    function open(form, extras, destination) {
      keepExistingGifts = required > 1 && claimed;
      pendingForm = form || mainForm();
      syncVersionGift(pendingForm);
      pendingExtras = safeExtras(extras);
      pendingDestination = destination === 'shop_pay' ? 'shop_pay' : 'cart';
      lastFocused = document.activeElement;
      setError('');
      confirmButton.textContent = pendingDestination === 'shop_pay' ? 'Continue to Shop Pay' : 'Add to cart';
      selected = required === 1 && giftOptions.length === 1 ? [gift] : [];
      renderSelection();
      modal.hidden = false;
      document.body.classList.add('ns-b1g2-modal-open');
      window.requestAnimationFrame(function () { dialog.focus(); });
    }
    function renderSelection() {
      var grid = root.querySelector('.ns-b1g2-grid');
      var summary = root.querySelector('[data-ns-native-promo-selection-summary]');
      if (summary) {
        summary.textContent = keepExistingGifts ? 'Your existing FREE gifts will stay in the cart.' : selected.length ? 'Selected: ' + selected.map(function (option) { return option.dataset.giftName || (option.querySelector('strong') || {}).textContent || 'FREE gift'; }).join(' · ') : 'No gifts selected yet';
      }
      if (grid) grid.hidden = keepExistingGifts;
      if (keepExistingGifts) {
        root.querySelector('[data-ns-native-promo-count]').textContent = claimedQuantity + '/' + required;
        root.querySelector('[data-ns-native-promo-status]').textContent = 'Your FREE gift offer is already in your cart. One selection per order.';
        confirmButton.disabled = busy;
        confirmButton.textContent = pendingDestination === 'shop_pay' ? 'Add saber & continue to checkout' : 'Add saber — keep my current gifts';
        return;
      }
      giftOptions.forEach(function (option) { option.setAttribute('aria-pressed', selected.indexOf(option) !== -1 ? 'true' : 'false'); });
      root.querySelector('[data-ns-native-promo-count]').textContent = selected.length + '/' + required;
      root.querySelector('[data-ns-native-promo-status]').textContent = selected.length === required ? 'Your FREE gifts are ready' : 'Choose ' + (required - selected.length) + ' more';
      confirmButton.disabled = busy || selected.length !== required;
      confirmButton.textContent = selected.length !== required ? 'Select ' + (required - selected.length) + ' more FREE gift' + (required - selected.length > 1 ? 's' : '') : pendingDestination === 'shop_pay' ? 'Continue to Shop Pay' : 'Add saber + ' + required + ' FREE gift' + (required > 1 ? 's' : '');
    }
    if (allGiftOptions.length > 1) allGiftOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        if (busy || option.disabled) return;
        var index = selected.indexOf(option);
        if (index !== -1) selected.splice(index, 1);
        else if (selected.length < required) selected.push(option);
        else { setError('Deselect a gift to choose a different style.'); return; }
        setError(''); renderSelection();
      });
    });
    function close() {
      if (busy) return;
      modal.hidden = true;
      document.body.classList.remove('ns-b1g2-modal-open');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      pendingForm = null;
      pendingExtras = [];
      pendingDestination = 'cart';
    }
    function removeBundle(cart, token) {
      var updates = {};
      (cart.items || []).forEach(function (item) {
        if (item.properties && item.properties['_NS promotion bundle'] === token) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return Promise.resolve();
      return requestJson(routesRoot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) }).catch(function () {});
    }
    function verify(cart, token) {
      var items = (cart.items || []).filter(function (item) { return item.properties && item.properties['_NS promotion bundle'] === token; });
      var offer = items.some(function (item) { return item.properties['_NS promotion offer'] === 'true'; });
      var gifts = items.filter(function (item) { return item.properties['_NS promotion gift'] === 'true'; });
      var allowed = giftOptions.map(function (option) { return Number(option.dataset.variantId); });
      return offer && gifts.length === required && new Set(gifts.map(function (item) { return item.id; })).size === required && gifts.every(function (item) { return item.quantity === 1 && item.original_line_price > 0 && item.final_line_price === 0 && allowed.indexOf(item.id) !== -1; });
    }
    function discountCodes(cart) {
      var values = [];
      (cart.discount_codes || []).forEach(function (discount) {
        var value = String(discount && discount.code || '').trim();
        if (value && values.indexOf(value) === -1) values.push(value);
      });
      if (code && values.indexOf(code) === -1) values.push(code);
      return values;
    }
    function applyAndVerify(token, tries, codes) {
      // Shopify applies the line-targeted automatic discount in the add request.
      // One fresh cart read verifies it; no artificial wait or code overwrite.
      if (root.dataset.discountMode === 'automatic') {
        function confirmAutomatic(remaining) {
          return requestJson(routesRoot() + 'cart.js').then(function (cart) {
            if (verify(cart, token)) return cart;
            if (remaining > 1) {
              var delay = remaining === 3 ? 250 : 450;
              return wait(delay).then(function () { return confirmAutomatic(remaining - 1); });
            }
            var error = new Error('Your FREE gift discount could not be confirmed. Please review your cart before trying again.');
            error.cart = cart;
            throw error;
          });
        }
        return confirmAutomatic(Math.max(1, Number(tries) || 3));
      }
      if (!codes) {
        return requestJson(routesRoot() + 'cart.js').then(function (cart) {
          return applyAndVerify(token, tries, discountCodes(cart));
        });
      }
      return requestJson(routesRoot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) })
        .then(function () { return wait(300); })
        .then(function () { return requestJson(routesRoot() + 'cart.js'); })
        .then(function (cart) {
          if (verify(cart, token)) return cart;
          if (tries > 1) return wait(400).then(function () { return applyAndVerify(token, tries - 1, codes); });
          var error = new Error('The promotion could not be confirmed. Your cart has not been changed. Please try again.');
          error.cart = cart;
          throw error;
        });
    }
    function addProductOnly(form, extras, destination) {
      if (busy) return;
      busy = true;
      setError('');
      var items;
      try { items = [formItem(form, null)].concat(safeExtras(extras)); } catch (error) { busy = false; setError(error.message); return; }
      requestJson(routesRoot() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { window.location.assign(destinationUrl(destination)); })
        .catch(function (error) { busy = false; setError(error.message || 'The product could not be added. Please try again.'); });
    }
    function addPromotion(form, extras, destination) {
      if (busy) return;
      if (keepExistingGifts) { addProductOnly(form, extras, destination); return; }
      if (selected.length !== required) return;
      busy = true;
      setError('');
      var token = 'ns-' + promoKey + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      var items;
      try { items = [formItem(form, token)].concat(selected.map(function (option) { return giftItem(token, option); }), safeExtras(extras)); } catch (error) { busy = false; setError(error.message); return; }
      confirmButton.disabled = true;
      confirmButton.textContent = 'Adding your saber and FREE gifts…';
      skipButton.disabled = true;
      var checkEligibility = window.NSLiveEligibility ? window.NSLiveEligibility.offer(promoKey, selected.map(function (o) { return o.dataset.variantId; }), required, items[0].id, root.dataset.nsRoutedProductHandle) : Promise.resolve();
      var beforeAdd = checkEligibility.then(function () { return required > 1 ? requestJson(routesRoot() + 'cart.js') : Promise.resolve(null); });
      beforeAdd.then(function (cart) {
        if (cart && hasValidBundle(cart)) {
          rememberClaim(cart); keepExistingGifts = true; busy = false; skipButton.disabled = false; renderSelection();
          setError('Your FREE gift offer is already in the cart. Confirm below to add only this saber, keeping your current gifts.');
          return false;
        }
        return requestJson(routesRoot() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
      })
        .then(function (added) { return added === false ? false : applyAndVerify(token, 3); })
        .then(function (cart) { if (cart !== false) window.location.assign(destinationUrl(destination)); })
        .catch(function (error) {
          var cartPromise = error.cart ? Promise.resolve(error.cart) : requestJson(routesRoot() + 'cart.js');
          cartPromise.then(function (cart) { return removeBundle(cart, token); }).catch(function () {}).finally(function () {
            busy = false;
            confirmButton.disabled = false;
            skipButton.disabled = false;
            renderSelection();
            setError(error.message || 'The promotion could not be added. Please try again.');
          });
        });
    }
    function startPromotion(form, extras, destination) {
      if (!form) { setError('The product form could not be found. Please refresh and try again.'); return; }
      if (promotionStartPending) return;
      promotionStartPending = true;
      giftReady.then(loadClaimed).then(function () {
        promotionStartPending = false;
        if (claimed && required <= 1) addProductOnly(form, extras, destination);
        else open(form, extras, destination);
      });
    }
    function loadClaimed() {
      if (claimStatePromise) return claimStatePromise;
      claimStatePromise = requestJson(routesRoot() + 'cart.js').then(function (cart) {
        rememberClaim(cart);
        return cart;
      }).catch(function () { return null; }).then(function (cart) { claimStatePromise = null; return cart; });
      return claimStatePromise;
    }
    function rememberClaim(cart) {
      claimed = hasValidBundle(cart);
      claimedQuantity = (cart.items || []).filter(function (item) { return item.properties && item.properties['_NS promotion key'] === promoKey && item.properties['_NS promotion gift'] === 'true'; }).reduce(function (sum, item) { return sum + item.quantity; }, 0);
      updateTrigger();
    }
    if (versionConfig) { syncVersionGift(mainForm()); document.addEventListener('variant:change', function () { syncVersionGift(mainForm()); }); document.addEventListener('change', function (event) { if (event.target && event.target.closest && event.target.closest('variant-picker, form[action*="/cart/add"]')) window.setTimeout(function () { syncVersionGift(mainForm()); }, 0); }); }
    closeButtons.forEach(function (button) { button.addEventListener('click', close); });
    confirmButton.addEventListener('click', function () {
      addPromotion(pendingForm || mainForm(), pendingExtras, pendingDestination);
    });
    skipButton.addEventListener('click', function () {
      var form = pendingForm || mainForm();
      var extras = pendingExtras.slice();
      var destination = pendingDestination;
      close();
      addProductOnly(form, extras, destination);
    });
    window.addEventListener('click', function (event) {
      if (root.dataset.nsEligibility === 'false') return;
      var openButton = event.target.closest('[data-ns-native-promo-open]');
      if (openButton) { event.preventDefault(); if (claimed) window.location.assign(cartUrl); else startPromotion(mainForm(), [], 'cart'); return; }
      var add = event.target.closest('button[data-action="add-to-cart"], input[data-action="add-to-cart"]');
      if (!add) return;
      var form = add.form || add.closest('form[action*="/cart/add"]');
      if (!isMainForm(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      startPromotion(form, [], 'cart');
    }, true);
    document.addEventListener('submit', function (event) {
      if (root.dataset.nsEligibility === 'false' || !isMainForm(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      startPromotion(event.target, [], 'cart');
    }, true);
    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(dialog.querySelectorAll('button:not(:disabled), [href], input:not(:disabled), [tabindex]:not([tabindex="-1"])')).filter(function (element) { return element.getClientRects().length > 0; });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    window.NSNativePromo = {
      start: function (form, extras) { startPromotion(form, extras, 'cart'); },
      startShopPay: function (form, extras) { startPromotion(form, extras, 'shop_pay'); }
    };
    ensureTrigger();
    loadClaimed();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Promotion-aware CTA copy. Presentation only; it never handles clicks or form submissions. */
(function () {
  'use strict';

  if (window.__nsPromoAtcLoaded) return;
  window.__nsPromoAtcLoaded = true;

  var refreshTimer = null;
  var observedForm = null;
  var formAbortController = null;

  function mainProductForm() {
    var supplement = document.querySelector('ns-ani-desktop-fill:not([hidden])');
    var mainRerender = supplement && supplement.closest('product-rerender[observe-form]');
    var supplementedForm = mainRerender && document.getElementById(mainRerender.getAttribute('observe-form'));
    if (supplementedForm && supplementedForm.matches('form[action*="/cart/add"]')) return supplementedForm;
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    return forms.find(function (form) { return form.querySelector('buy-buttons') && !form.closest('[id*="quick-buy"], quick-buy-modal, .quick-buy-modal'); }) ||
      forms.find(function (form) { return form.matches('form[is="product-form"]') && !form.closest('[id*="quick-buy"], quick-buy-modal, .quick-buy-modal'); }) || null;
  }

  function spendEligible() {
    var config = window.NSGiftCampaignConfig || {};
    var entry = config.productEntry;
    if (!config.enabled || !entry || !entry.productId || !config.spend || !config.spend.enabled) return false;
    var blockedHandles = [
      'bogo-free-saber-copy', '2-free-dueling-sabers', '4-free-dueling-sabers',
      '2-free-sabers-gift', 'bogo-free-saber',
      'free-luke-v1', 'free-darksaber'
    ];
    if (blockedHandles.indexOf(String(entry.handle || '').toLowerCase()) !== -1) return false;
    var eligible = config.spend.eligibleProductIds;
    return (!Array.isArray(eligible) || eligible.map(Number).indexOf(Number(entry.productId)) !== -1) &&
      (config.spend.excludedProductIds || []).map(Number).indexOf(Number(entry.productId)) === -1;
  }

  function promotionKey() {
    var nativeRoot = document.querySelector('[data-ns-native-promo]');
    if (nativeRoot && nativeRoot.dataset.nsEligibility !== 'false' && nativeRoot.dataset.promoKey) return nativeRoot.dataset.promoKey;
    if (window.NSPromoAtcConfig && window.NSPromoAtcConfig.isBundle) return 'bundle';
    if (spendEligible()) return 'spend';
    return '';
  }

  function ctaLabel(key) {
    var giftRoot = document.querySelector('[data-ns-native-promo]');
    if (key === 'freeluke' && giftRoot && document.querySelector('[data-ns-obi-offer-template]') && giftRoot.dataset.obiGiftCta) return giftRoot.dataset.obiGiftCta;
    if (key === 'freeluke' && giftRoot && giftRoot.dataset.giftHandle === 'free-luke-v1' && giftRoot.dataset.required === '1' && giftRoot.dataset.giftChoices !== 'true') return 'Add to Cart + FREE Luke V1';
    var display = window.NSPromoAtcConfig && window.NSPromoAtcConfig.display;
    var custom = display && display[key] && display[key].button_text;
    if (typeof custom === 'string' && custom.trim() && custom.length <= 64 && !/[<>\x00-\x1f]/.test(custom)) return custom.trim();
    var labels = {
      choose2: 'Choose Your 2 FREE Sabers',
      b1g2: 'Add to Cart + 2 FREE Sabers',
      bogo: 'Add to Cart + 1 FREE Saber',
      freeluke: 'Add to Cart + FREE Master Saber',
      bounty: 'Add to Cart + FREE Darksaber',
      bundle: 'Add Bundle to Cart — Save up to 50%',
      spend: 'Add to Cart — Unlock FREE Sabers'
    };
    var root = document.querySelector('[data-ns-native-promo]');
    var configured = root && root.dataset.promoKey === key && root.dataset.buttonText;
    if (configured && configured.length <= 64 && !/[<>\x00-\x1f]/.test(configured)) return configured;
    return labels[key] || (root && root.dataset.promoKey === key ? 'Add to Cart + FREE Gift' : '');
  }

  function routesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  }

  function setShopPayError(button, message) {
    var host = button && button.closest('.shopify-payment-button');
    var error = host && host.querySelector('[data-ns-promo-shop-pay-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function runShopPay(button, form, key) {
    if (!button || button.disabled) return;
    setShopPayError(button, '');

    var nativePromoRoot = document.querySelector('[data-ns-native-promo]');
    if (nativePromoRoot && nativePromoRoot.dataset.nsEligibility !== 'false' && window.NSNativePromo && typeof window.NSNativePromo.startShopPay === 'function') {
      window.NSNativePromo.startShopPay(form, []);
      return;
    }

    if (!window.NSGiftCampaign || typeof window.NSGiftCampaign.fastCheckout !== 'function') {
      setShopPayError(button, 'Shop Pay is still loading. Please try again.');
      return;
    }

    var original = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Preparing your gifts…';
    window.NSGiftCampaign.fastCheckout(form)
      .then(function () { window.location.assign(routesRoot() + 'checkout?payment=shop_pay'); })
      .catch(function (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.innerHTML = original;
        setShopPayError(button, error && error.message || 'Shop Pay could not start. Please try again.');
      });
  }

  function ensureShopPayButton(form, key, label) {
    if (!form) return;
    var host = form.querySelector('.shopify-payment-button');
    var group = form.querySelector('buy-buttons');
    if (!host && label && group) {
      host = document.createElement('div');
      host.className = 'shopify-payment-button';
      group.appendChild(host);
    }
    if (!host) return;

    var existing = host.querySelector('[data-ns-promo-shop-pay]');
    if (!label) {
      if (existing) existing.remove();
      host.classList.remove('ns-promo-shop-pay-host');
      return;
    }

    host.classList.add('ns-promo-shop-pay-host');
    var button = existing;
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'ns-promo-shop-pay';
      button.setAttribute('data-ns-promo-shop-pay', '');
      button.setAttribute('aria-label', 'Buy with Shop Pay');
      button.innerHTML = '<span>Buy with</span><strong>shop</strong><span class="ns-promo-shop-pay__pay">Pay</span>';
      button.addEventListener('click', function () { runShopPay(button, mainProductForm(), button.dataset.nsPromoKey || ''); });
      host.appendChild(button);
      var error = document.createElement('p');
      error.className = 'ns-promo-shop-pay__error';
      error.setAttribute('data-ns-promo-shop-pay-error', '');
      error.setAttribute('role', 'alert');
      error.hidden = true;
      host.appendChild(error);
    }
    button.dataset.nsPromoKey = key;
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function buttonCandidates(form) {
    if (!form) return [];
    var result = Array.prototype.slice.call(form.querySelectorAll('buy-buttons button[type="submit"]'));
    if (form.id) {
      Array.prototype.slice.call(document.querySelectorAll('buy-buttons button[type="submit"][form="' + cssEscape(form.id) + '"]')).forEach(function (button) {
        if (result.indexOf(button) === -1) result.push(button);
      });
    }
    return result.filter(function (button) {
      return !button.closest('.shopify-payment-button') && !button.closest('[data-ns-native-promo]');
    });
  }

  function restoreButton(button) {
    var previousLabel = ctaLabel(button.dataset.nsPromoAtcKey || '');
    if (button.classList.contains('ns-promo-atc') && button.textContent.trim() === previousLabel && button.dataset.nsPromoAtcOriginal) {
      button.textContent = button.dataset.nsPromoAtcOriginal;
    }
    if (button.classList.contains('ns-promo-atc')) {
      if (button.dataset.nsPromoAtcOriginalAria) button.setAttribute('aria-label', button.dataset.nsPromoAtcOriginalAria);
      else button.removeAttribute('aria-label');
    }
    button.classList.remove('ns-promo-atc');
    delete button.dataset.nsPromoAtcKey;
  }

  function decorateButton(button, key, label) {
    if (!button.dataset.nsPromoAtcOriginal) button.dataset.nsPromoAtcOriginal = button.textContent.trim();
    if (!button.dataset.nsPromoAtcAriaSaved) {
      button.dataset.nsPromoAtcAriaSaved = 'true';
      button.dataset.nsPromoAtcOriginalAria = button.getAttribute('aria-label') || '';
    }
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
      restoreButton(button);
      return;
    }
    if (button.dataset.nsPromoAtcKey !== key || button.textContent.trim() !== label) button.textContent = label;
    button.dataset.nsPromoAtcKey = key;
    button.setAttribute('aria-label', label);
    button.classList.add('ns-promo-atc');
    var group = button.closest('buy-buttons');
    if (group) group.classList.add('ns-promo-atc-group');
  }

  function bindForm(form) {
    if (!form || observedForm === form) return;
    if (formAbortController) formAbortController.abort();
    observedForm = form;
    formAbortController = new AbortController();
    form.addEventListener('product:rerender', schedule, { signal: formAbortController.signal });
    form.addEventListener('variant:change', schedule, { signal: formAbortController.signal });
  }

  function refresh() {
    var form = mainProductForm();
    bindForm(form);
    var key = promotionKey();
    var label = ctaLabel(key);
    var buttons = buttonCandidates(form);
    document.body.classList.toggle('ns-promo-atc-active', Boolean(label));
    document.body.dataset.nsPromoAtc = key || '';

    buttons.forEach(function (button) {
      if (label) decorateButton(button, key, label);
      else restoreButton(button);
    });
    ensureShopPayButton(form, key, label);

    Array.prototype.slice.call(document.querySelectorAll('buy-buttons.ns-promo-atc-group')).forEach(function (group) {
      if (!group.querySelector('.ns-promo-atc')) group.classList.remove('ns-promo-atc-group');
    });
  }

  function schedule() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 40);
  }

  function start() {
    refresh();
    document.addEventListener('ns:eligibility', schedule);
  document.addEventListener('variant:change', schedule);
    window.addEventListener('pageshow', schedule);
    window.NSPromoAtc = { refresh: schedule };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
